var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",on:{"click":_vm.toIndex}},[_c('div',{staticClass:"header-title"},[_c('h1',[_vm._v("福建省国有企业招聘考试报名网")]),_c('h2',[_vm._v("("+_vm._s(_vm.title)+")")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-tip"},[_c('div',[_vm._v("公开")]),_c('div',[_vm._v("平等")]),_c('div',[_vm._v("竞争")]),_c('div',[_vm._v("择优")])])
}]

export { render, staticRenderFns }